import {
    GET_ALL_PAGES
} from './constants';

const initialState = {
    allPages: [],
};

export default (state = initialState, action) => {
    switch (action.type) {
        case GET_ALL_PAGES: {
            return {
                ...state,
                allPages: action.payload,
            };
        }
        default:
            return state;
    }
};

